<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Profile Side Panel"
    seFeDataSubtitle="A shared profile side panel feature"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this feature to display profile and admin permission details in a side panel.</p>
        </se-fe-card-content>
      </se-fe-card>
      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-feature-profile-side-panel-example></se-po-feature-profile-side-panel-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
